import { Injectable } from "@angular/core";
import { Http, Headers, Response } from "@angular/http";
import { CONFIG } from "../config";
import { map } from "rxjs/operator/map";
import { Observable } from "rxjs";

@Injectable()
export class EmailService {
    constructor(private http: Http) {

    }

    send(name: string, email: string, link: string, storeId: number): Observable<{ message: string, success: boolean }> {
        let contentHeaders = new Headers();
        contentHeaders.append('Accept', 'application/json');
        contentHeaders.append('Content-Type', 'application/json');
        let url = CONFIG.apiPath + "api/index.php";

        let body = {
            "store": storeId,
            "email": email,
            "name": name,
            "link": link
        };
        // return new Observable<{message: string, success: boolean}>((observer) => {
        //     observer.next({success: true, message:"asdasd"});
        //     observer.complete();
        // });
        return this.http.post(url, JSON.stringify(body), { headers: contentHeaders })
            .map((res: Response) => {
                let body = res.json();
                return body;
            })
            .catch(this.handleError);
    }

    handleError(error: Response) {
        let json = error.json();
        let msg = "server error, status " + error.status;
        if (json && json.message) {
            msg = json.message;
        }
        console.error(error.status + ": " + msg); // log to console instead

        return Observable.throw(msg);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/email.service.ts